<template>
  <section>
    <a href target="_blank" rel="noopener noreferrer">
      <img src="/static/images/topguanggao.png" alt srcset class="topguanggao" />
    </a>
    <Header :indexData="indexData" :userInfo="userInfo" :keyword="keyword"></Header>

    <div class="container">
      <div class="path">
        首页
        <i class="iconfont icon-right"></i>
        {{productdetail.title}}
        <i class="iconfont icon-right"></i>
        {{selectedItemObj.keyname}}
      </div>
      <div class="product-main">
        <div class="clearfix">
          <div class="product-imgshow">
            <div id="preview" class="spec-preview">
              <div class="jqzoom">
                <img :jqimg="selectedItemObj.indexpic" :src="selectedItemObj.indexpic" />
              </div>
            </div>
            <div class="spec-scroll">
              <a class="prev">
                <span class="iconfont icon-left"></span>
              </a>
              <a class="next">
                <span class="iconfont icon-right"></span>
              </a>
              <div class="items">
                <ul class="clearlist">
                  <li
                    v-for="(item,index) in productdetail.images"
                    class
                    :data-src="item.src"
                    :data-bigimg="item.src"
                    :key="index"
                    data-alt
                  >
                    <img :src="item.src" />
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="product-info">
            <div class="productname">{{productdetail.title}}</div>
            <div class="miaoshadDetail flex ju-be" v-if="productdetail.isgroup>0">
             <div> <span class="iconfont icon-time"></span>
              <span>快力文秒杀</span></div>
              <div class="flex">距离结束
                <span class="color-black">{{count_time[0]}}</span>:
                <span class="color-black">{{count_time[1]}}</span>:
                <span class="color-black">{{count_time[2]}}</span>
              </div>
            </div>
            <div class="jiage">
              <div class="item">
                <div class="tit">价格</div>
                <div class="cont color-primary">
                  <!-- <span style="font-size: 18px;">￥</span> -->
                  <span class="price">{{selectedItemObj.price}} </span><span style="font-size: 18px;">积分</span>
                </div>
              </div>
              <!-- <div class="item">
								<div class="tit">优惠</div>
								<div class="cont color-primary">可使用满1000减200抵用券</div>
              </div>-->
            </div>
            <div class="info">
              <div class="item">
                库存
                <span class="color-primary">{{selectedItemObj.stock}}</span>
              </div>
              <div class="item">
                销量
                <span class="color-primary">{{selectedItemObj.sold}}</span>
              </div>
              <div class="item">免运费</div>
            </div>
            <div class="canshu" v-if="ismulti">
              <div class="item" v-for="(item) in productdetail.speclist" :key="item.id">
                <div class="tit">{{item.name}}：</div>
                <div class="cont">
                  <ul class="clearlist clearfix">
                    <li
                      class
                      :faid="item.id"
                      :id="item_i[0]"
                      @click="specification(item.id,item_i[0])"
                      v-for="(item_i) in item.child"
                      :key="item_i.id"
                    >
                      <a href="javascript:;">{{item_i[1]}}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="shuliang">
              <div class="tit">数量</div>
              <div class="numbers">
                <input type="text" min="0" v-model="num" />
                <div class="jiajian">
                  <a href="javascript:;" @click="changeNum('add',selectedItemObj.stock)">
                    <i class="iconfont icon-up"></i>
                  </a>
                  <a href="javascript:;" @click="changeNum('reder',selectedItemObj.stock)">
                    <i class="iconfont icon-down"></i>
                  </a>
                </div>
              </div>
              <div>{{productdetail.unit}}</div>
            </div>
            <div class="btnbox">
              <a href="javascript:;" class="layui-btn" @click="goBuy">立即兑换</a>
              <!-- <a href="javascript:;" class="layui-btn layui-btn-primary" @click="addCar" v-if="productdetail.isgroup==0">加入购物车</a> -->
              <!-- <a href="jiesuan.html" class="layui-btn">立即购买</a> -->
              <!-- <a href="cart.html" class="layui-btn  layui-btn-primary">加入购物车</a> -->
            </div>
          </div>
        </div>
        <div class="product-title">
          <h2 class="active">商品详情</h2>
          <!-- <h2>商品参数</h2>
          <h2>商品评价</h2>-->
        </div>
        <div class="product-content">
          <div class="pt-item" v-html="productdetail.content">
            <!-- <p style="text-align: center;"><img src="images/cpxximg.jpg"></p> -->
          </div>
          <div class="pt-item hide">产品参数</div>
          <div class="pt-item hide">
            <div class="plbox">
              <div class="pl-hd">
                <div class="pl-touxiang">
                  <img src="images/touxiang.jpg" />
                </div>
                <div class="name">用户昵称</div>
              </div>
              <div class="pl-bd">
                <div>
                  <span class="star star04"></span>
                </div>
                <div>给老人买的，还没吃，不过看上去很不错，个头饱满，第二件半价很划算，谢谢老板送的山楂，好评！</div>
                <div class="pl-img">
                  <div class="clearfix imgtab">
                    <a href="images/banner.jpg">
                      <img src="images/cpimg.jpg" />
                    </a>
                    <a href="images/cpbig.jpg">
                      <img src="images/cpbig.jpg" />
                    </a>
                    <a href="images/cpimg.jpg">
                      <img src="images/cpimg.jpg" />
                    </a>
                    <a href="images/cpbig.jpg">
                      <img src="images/cpbig.jpg" />
                    </a>
                  </div>
                  <div class="bigcpimg hide">
                    <a href="javascript:;" class="close">
                      <span class="iconfont icon-up"></span>
                      收起
                    </a>
                    <a href="javascript:;" class="btnprev">
                      <span class="iconfont icon-left"></span>
                    </a>
                    <a href="javascript:;" class="btnnext">
                      <span class="iconfont icon-right"></span>
                    </a>
                    <img class="img" src />
                  </div>
                </div>
                <div class="pl-info">2017-01-28 颜色：黑色 尺寸：50寸</div>
              </div>
            </div>
            <div class="plbox">
              <div class="pl-hd">
                <div class="pl-touxiang">
                  <img src="images/touxiang.jpg" />
                </div>
                <div class="name">用户昵称</div>
              </div>
              <div class="pl-bd">
                <div>
                  <span class="star star04"></span>
                </div>
                <div>给老人买的，还没吃，不过看上去很不错，个头饱满，第二件半价很划算，谢谢老板送的山楂，好评！</div>
                <div class="pl-img">
                  <div class="clearfix imgtab">
                    <a href="images/cpimg.jpg">
                      <img src="images/cpimg.jpg" />
                    </a>
                    <a href="images/cpbig.jpg">
                      <img src="images/cpbig.jpg" />
                    </a>
                    <a href="images/cpimg.jpg">
                      <img src="images/cpimg.jpg" />
                    </a>
                    <a href="images/cpbig.jpg">
                      <img src="images/cpbig.jpg" />
                    </a>
                  </div>
                  <div class="bigcpimg hide">
                    <a href="javascript:;" class="close">
                      <span class="iconfont icon-up"></span>
                      收起
                    </a>
                    <a href="javascript:;" class="btnprev">
                      <span class="iconfont icon-left"></span>
                    </a>
                    <a href="javascript:;" class="btnnext">
                      <span class="iconfont icon-right"></span>
                    </a>
                    <img class="img" src />
                  </div>
                </div>
                <div class="pl-info">2017-01-28 颜色：黑色 尺寸：50寸</div>
              </div>
            </div>
            <div class="plbox">
              <div class="pl-hd">
                <div class="pl-touxiang">
                  <img src="images/touxiang.jpg" />
                </div>
                <div class="name">用户昵称</div>
              </div>
              <div class="pl-bd">
                <div>
                  <span class="star star04"></span>
                </div>
                <div>给老人买的，还没吃，不过看上去很不错，个头饱满，第二件半价很划算，谢谢老板送的山楂，好评！</div>
                <div class="pl-img">
                  <div class="clearfix imgtab">
                    <a href="images/cpimg.jpg">
                      <img src="images/cpimg.jpg" />
                    </a>
                    <a href="images/cpbig.jpg">
                      <img src="images/cpbig.jpg" />
                    </a>
                    <a href="images/cpimg.jpg">
                      <img src="images/cpimg.jpg" />
                    </a>
                    <a href="images/cpbig.jpg">
                      <img src="images/cpbig.jpg" />
                    </a>
                  </div>
                  <div class="bigcpimg hide">
                    <a href="javascript:;" class="close">
                      <span class="iconfont icon-up"></span>
                      收起
                    </a>
                    <a href="javascript:;" class="btnprev">
                      <span class="iconfont icon-left"></span>
                    </a>
                    <a href="javascript:;" class="btnnext">
                      <span class="iconfont icon-right"></span>
                    </a>
                    <img class="img" src />
                  </div>
                </div>
                <div class="pl-info">2017-01-28 颜色：黑色 尺寸：50寸</div>
              </div>
            </div>
            <div class="plbox">
              <div class="pl-hd">
                <div class="pl-touxiang">
                  <img src="images/touxiang.jpg" />
                </div>
                <div class="name">用户昵称</div>
              </div>
              <div class="pl-bd">
                <div>
                  <span class="star star04"></span>
                </div>
                <div>给老人买的，还没吃，不过看上去很不错，个头饱满，第二件半价很划算，谢谢老板送的山楂，好评！</div>
                <div class="pl-img">
                  <div class="clearfix imgtab">
                    <a href="images/cpimg.jpg">
                      <img src="images/cpimg.jpg" />
                    </a>
                    <a href="images/cpbig.jpg">
                      <img src="images/cpbig.jpg" />
                    </a>
                    <a href="images/cpimg.jpg">
                      <img src="images/cpimg.jpg" />
                    </a>
                    <a href="images/cpbig.jpg">
                      <img src="images/cpbig.jpg" />
                    </a>
                  </div>
                  <div class="bigcpimg hide">
                    <a href="javascript:;" class="close">
                      <span class="iconfont icon-up"></span>
                      收起
                    </a>
                    <a href="javascript:;" class="btnprev">
                      <span class="iconfont icon-left"></span>
                    </a>
                    <a href="javascript:;" class="btnnext">
                      <span class="iconfont icon-right"></span>
                    </a>
                    <img class="img" src />
                  </div>
                </div>
                <div class="pl-info">2017-01-28 颜色：黑色 尺寸：50寸</div>
              </div>
            </div>
            <div id="fenye" style="padding: 20px 0; text-align: center;"></div>
          </div>
        </div>
      </div>
      <div class="product-side">
        <div class="sitit">看了又看</div>
        <div class="liulanjilu">
          <ul class="clearlist">
            <li v-for="(item,index) in CanAgincan.data">
              <a :href="'#/goodsdetail?id='+item.id" target="_blank">
                <div class="img">
                  <img :src="item.indexpic" />
                </div>
                <div class="name">{{item.title}}</div>
                <div class="price">￥{{item.price}}</div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Footer :indexData="indexData"></Footer>
  </section>
</template>

<script>
import Header from "../components/header";
import Footer from "../components/footer";

layui.use(["layer"], function() {
  layer = layui.layer;
});
export default {
  components: {
    Header,
    Footer
  },
  name: "goodsdetail",
  data() {
    return {
      num: 1,
      id: getParameterByName("id"),
      guid: sessionStorage.guid,
      productdetail: {}, //产品详情的数据
      ismulti: false, //是否是多规格
      CanAgincan: {}, //看了又看的商品
      selectedItemArr: [],
      autotroph: sessionStorage.autotroph,
      selectedItemObj: {},
      indexData: {},
      keyword: decodeURI(getQueryVariable("keyword")),
      userInfo: {},
      count_time:['00','00','00'],
      cainixihuan: {}
    };
  },
  methods: {
    // 封装获取数据的方法
    async getProductdetail() {
      let that=this;
      let res = await this.$fetch("shop/giftdetail", {
        body: { id: this.id }
      });
      //   let res = ajaxMethod("productdetail", { id: this.id });
      if (res.images) {
        res.images = JSON.parse(res.images);
      }
      res.sold = res.sold + res.soldinit + res.solds;
      this.ismulti = res.ismulti;
      let obj = {
        indexpic: res.indexpic,
        sold: res.sold + res.soldinit + res.solds,
        stock: res.stock,
        price: res.price,
        title: res.title
      };

      if (res.ismulti == 1) {
        this.ismulti = true;
        obj.stock = res.stocks;
        for (let key in res.speclist) {
          this.selectedItemArr.push("");
        }
      }
      this.selectedItemObj = obj;
      this.productdetail = res;
      //  alert("dfcerg",this.selectedItemObj.isgroup)
       if (this.productdetail.isgroup >0) {
        
        let item=this.productdetail;
        let countTime = item.timeto - item.timefrom;
          let timeId = setInterval(function() {
          that.count_time = getDate(countTime);
          console.log(that.count_time);
          countTime--;
          if (countTime <= 0) {
            clearInterval(timeId);
          }
        }, 1000);
      }
    },
    // 看了又看的商品
    async getCanAgincan() {
      this.CanAgincan = await this.$fetch("Shop/productlist", {
        body: {
          isresume: 1,
          page: 1,
          size: 5,
          categoryid: this.productdetail.categoryid,
          guid: this.guid
        }
      });
    
    },
    // 点击切换规格
    specification(faItem, id) {
      let speclist = this.productdetail.speclist;
      let isAll = true;
      for (let i = 0; i < speclist.length; i++) {
        if (faItem == speclist[i].id) {
          this.selectedItemArr[i] = id;
        }
      }
      // 判断是否选全了规格
      for (let i = 0; i < speclist.length; i++) {
        if (!speclist[i]) {
          isAll = false;
        }
      }
      if (isAll) {
        let specvalue = this.productdetail.specvalue;
        let str = this.selectedItemArr.join("_");
        for (let key in specvalue) {
          if (key == str) {
            let obj = specvalue[key];
            obj["id"] = key;
            this.selectedItemObj = obj;
            console.log(this.selectedItemObj);
          }
        }
      }
    },

    // 点击立即购买按钮
    async goBuy() {
      let submitorder = this.selectedItemObj;
      if (this.num > submitorder.stock) {
        layer.alert("不能超过最大库存", { icon: 2 });
        return;
      }
      if (!this.guid) {
        this.$router.push("/login");
        return;
      }

    //   if (this.ismulti) {
    //     if (!submitorder.id) {
    //       layer.alert("请选择完整的规格", { icon: 2 });
    //       return;
    //     }
    //   }
      // 判断是否是秒杀商品
    //   if(this.productdetail.isgroup>0){
        // alert("即将去结算页面")
        this.$router.push({path:'/jiesuan',
          query: {
            productid: this.id,
            jifen:true,
            // specification: this.selectedItemObj.id,
            num: this.num
          }
        })
        //  this.$router.push("/jiesuan");
    //   }else{
    //     submitorder["title"] = this.productdetail.title;
    //     submitorder["num"] = this.num;
    //     let res = await this.$fetch("Cart/edit", {
    //       body: {
    //         productid: this.id,
    //         specification: this.selectedItemObj.id,
    //         guid: this.guid,
    //         num: this.num
    //       }
    //     });
    //   this.$router.push("/cart");
    //   }
    },

    // 修改数量
    changeNum(type, stock) {
      let num = Number(this.num);
      if (type == "add") {
        if (num >= stock) {
          return;
        }
        this.num = num + 1;
      } else {
        if (num <= 1) {
          this.num = 1;
          return;
        }
        this.num = num - 1;
      }
      console.log(this.num);
    }
  },

  async mounted() {
    console.log("开始发起请求");
    //   return;
    this.indexData = await this.$fetch("Index/indexdata");
    console.log("发起请求成功");
    this.getProductdetail();
    this.getCanAgincan();
    if (sessionStorage.user) {
      this.userInfo = JSON.parse(sessionStorage.user);
    }
    // 一些配置
    $(".nav-service").hover(
      function() {
        $(this)
          .find(".downmenu")
          .slideDown("fast");
      },
      function() {
        $(this)
          .find(".downmenu")
          .stop()
          .slideUp("fast");
      }
    );
    layui.use(["laypage"], function() {
      var laypage = layui.laypage;
      laypage.render({
        elem: "fenye",
        count: 100,
        layout: ["prev", "page", "next", "count", , "skip"],
        jump: function(obj) {
          console.log(obj);
        }
      });
    });
    $(".product-title h2").on("click", function() {
      $(this)
        .addClass("active")
        .siblings()
        .removeClass("active");
      $(".product-content .pt-item")
        .eq($(this).index())
        .removeClass("hide")
        .siblings()
        .addClass("hide");
    });
    $.each($(".pl-img"), function() {
      var _this = $(this);
      _this.find(".imgtab a").on("click", function() {
        $(this)
          .addClass("active")
          .siblings()
          .removeClass("active");
        _this.find(".bigcpimg").removeClass("hide");
        _this.find(".bigcpimg .img").attr("src", $(this).attr("href"));
        return false;
      });
      _this.find(".bigcpimg .close").on("click", function() {
        _this.find(".bigcpimg").addClass("hide");
        _this.find(".imgtab a").removeClass("active");
      });
      _this.find(".bigcpimg .btnprev").on("click", function() {
        if (_this.find(".imgtab a.active").index() > 0) {
          _this.find(".bigcpimg .img").attr(
            "src",
            _this
              .find(".imgtab a")
              .eq(_this.find(".imgtab a.active").index() - 1)
              .attr("href")
          );
          _this
            .find(".imgtab a")
            .eq(_this.find(".imgtab a.active").index() - 1)
            .addClass("active")
            .siblings()
            .removeClass("active");
        }
      });
      _this.find(".bigcpimg .btnnext").on("click", function() {
        if (
          _this.find(".imgtab a.active").index() <
          _this.find(".imgtab a").length - 1
        ) {
          _this.find(".bigcpimg .img").attr(
            "src",
            _this
              .find(".imgtab a")
              .eq(_this.find(".imgtab a.active").index() + 1)
              .attr("href")
          );
          _this
            .find(".imgtab a")
            .eq(_this.find(".imgtab a.active").index() + 1)
            .addClass("active")
            .siblings()
            .removeClass("active");
        }
      });
    });
    $(".canshu li").on("click", function() {
      $(this)
        .addClass("active")
        .siblings()
        .removeClass("active");
    });
  }
};
</script>

  


<style lang='scss' scoped>
.topguanggao {
  width: 100%;
}
.el-carousel__item {
  height: 450px;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.el-carousel__indicators {
  .el-carousel__indicator {
    margin-right: 10px !important;
  }
}

/* .el-carousel__indicator {
	  background: red;
  } */
</style>



// WEBPACK FOOTER //
// src/pages/test.vue